import { apiClient } from '../../../../v4/core/apiClient';
import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myBookingApi } from 'v5/api/booking/booking.api.connected';
import { createProductionApi } from 'v5/api/production/production.api.http';
import { createResourcingApi } from 'v5/api/resourcing/resourcing.api.http';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { myMetastructureMappingService } from '../../internal/MetastructureMappingService/MetastructureMappingService.connected';
import { createProductionMutationService } from './ProductionMutationService.impl';

export const myProductionMutationService = createProductionMutationService({
  api: createProductionApi({
    client: apiClient,
    services: { metastructureMappingService: myMetastructureMappingService }
  }),
  bookingApi: myBookingApi,
  resourcingApi: createResourcingApi({ client: apiClient }),
  queryClient,
  services: {
    errorService: myErrorService,
    messageService: myMessageService
  }
});
